module.exports = __webpack_public_path__ + "static/media/add_clients_card_3.fac560e1.svg";